import { render, staticRenderFns } from "./ResultsSummary.vue?vue&type=template&id=2d8136fc"
import script from "./ResultsSummary.vue?vue&type=script&lang=js"
export * from "./ResultsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports